<template>
  <b-container fluid class="my-4">
    <b-row>
      <b-col cols="12" md="8" lg="6" class="mx-auto">
        <b-card title="Encuesta Atención Médica">
          <validation-observer v-slot="{ invalid }" ref="observer">
            <b-form @submit.prevent="submitForm">
              <b-form-group>
                <!-- <label>Califique la calidad de la atención médica recibida: <span class="text-danger">*</span></label>
                  <div class="d-flex align-items-center">
                    <b-form-select v-model="calidad" placeholder="Seleccione una opcion:">
            <option value="0">Muy Mala</option>
            <option value="1">Mala</option>
            <option value="2">Regular</option>
            <option value="3">Buena</option>
            <option value="4">Excelente</option>
          </b-form-select>
         
               </div> -->
                <label for="rating-md-no-border" class="mt-3"
                  >Califique la cita:
                </label>
                <b-form-rating
                  id="rating-md-no-border"
                  v-model="calidad"
                  no-border
                ></b-form-rating>
              </b-form-group>

              <b-form-group>
                <label
                  >Coloque sus observaciones:
                  <span class="text-danger">*</span></label
                >
                <validation-provider
                  #default="{ errors }"
                  name="observaciones"
                  rules="required"
                >
                  <b-form-textarea
                    id="observaciones"
                    :state="errors.length > 0 ? false : null"
                    v-model="observaciones"
                    type="text"
                    size="large"
                    rows="5"
                    max-rows="10"
                    placeholder="Escriba sus observaciones aquí..."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-button type="submit" variant="primary" :disabled="invalid"
                >Enviar Calificación</b-button
              >
            </b-form>
          </validation-observer>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from "axios";
import rutas from "@/assets/utils/rutas.json";
import vSelect from "vue-select";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import {
  BFormRating,
  BContainer,
  BFormSelect,
  BRow,
  BCol,
  BCard,
  BFormTextarea,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BFormCheckbox,
} from "bootstrap-vue";

export default {
  components: {
    BFormRating,
    BContainer,
    BRow,
    BCol,
    BCard,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BFormCheckbox,
    BFormSelect,
    ValidationProvider,
    ValidationObserver,
    BFormTextarea,
    vSelect,
  },
  data() {
    return {
      encuesta: {
        id: "",

        estado: "1",
      },
      calidad: null,
      observaciones: "",
      tokena:"",
      doctori: "",
      pacientei:"",
    };
  },
  created() {
    // aqui se colocan las funciones que aparezcan cargadas cuando se haga un post o un f5 de la misma.
    //const idImagen = this.$route.params.id;
    //console.log(idImagen);
    const tokencita = this.$route.params.token;
    const partesToken = tokencita.split(".");

    // Asignar cada parte a las variables correspondientes
    this.tokena = partesToken[0];
    this.doctori = partesToken[1];
    this.pacientei = partesToken[2];

    // Imprimir las variables para verificar
    console.log("tokenencuestacita:", tokenencuestacita);
    console.log("doctorid:", doctorid);
    console.log("pacienteid:", pacienteid);
    this.fetchCitaToken(tokencita);
    //this.fetchtipoImagen();
  },
  methods: {
    async fetchCitaToken(tokencita) {
      const query = `
      query MyQuery($tokencita: String!) {
  getTokenCita(tokenCita: $tokencita) {
    message
    status
    cita {
      id
    }
  }
}
                    `;

      const variables = {
        tokencita: tokencita,
      };
      try {
        const response = await axios.post(rutas.axios + "api", {
          query: query,
          variables: variables,
        });
        console.log(response);
        this.citaid = response.data.data.getTokenCita.cita.id;
      } catch (error) {
        console.error("An error occurred while fetching the options:", error);
      }
    },

    async submitForm() {
      const query = `
      mutation generarEncuestaCita($calificacion: String!, $doctor: ID!, $observaciones: String!, $paciente: ID!, $tokenaleatorio: String!) {
  crearEncuestaCita(
    encuestaData: {calificacion: $calificacion, doctor: $doctor, observaciones: $observaciones, paciente: $paciente, tokenaleatorio: $tokenaleatorio}
  ) {
    message
    status
  }
}
        `;

      const variables = {
        calificacion: this.calidad.toString(),
        observaciones: this.observaciones,
        doctor:this.doctori,
        paciente:this.pacientei,
        tokenaleatorio: this.tokena,
      };
      console.log(variables);

      try {
        // Realizar la solicitud GraphQL utilizando axios
        const response = await axios.post(rutas.axios + "api", {
          query: query,
          variables: variables,
        });
        console.log("imprimir response", response.data.data.crearEncuestaCita);

        // Verificar si la operación fue exitosa
        if (response.data.data.crearEncuestaCita.status === "success") {
          // Mostrar una alerta de éxito
          await this.$swal({
            icon: "success",
            title: "Éxito",
            text: "La encuesta se creó correctamente.",
          });

          // Redirigir a otra página si es necesario

          this.$router.push({ name: "/" });

          // Limpiar el formulario o realizar otras acciones necesarias
          // this.medicamento = { ... };
        } else {
          this.$swal({
            title: "Error",
            text: response.data.data.crearEncuestaCita.message,
            icon: "error",
            confirmButtonColor: "#089599",
          });
        }
      } catch (error) {
        // Mostrar una alerta de error si la solicitud falla
        await this.$swal({
          icon: "error",
          title: "Error",
          text: error.message || "Hubo un problema al crear la imagen.",
        });
      }
    },
  },
};
</script>
